<mat-expansion-panel class="panel">
  <mat-expansion-panel-header>
    <mat-panel-title>{{ 'ASSOCIATIONS.CAMPAIGNS.TITLE' | translate }}</mat-panel-title>
  </mat-expansion-panel-header>
  <button mat-stroked-button color="primary" class="association-button" (click)="addCampaigns()">
    <mat-icon>add</mat-icon> {{ 'ASSOCIATIONS.CAMPAIGNS.ADD_ASSOCIATION' | translate }}
  </button>
  <ng-container *ngFor="let campaign of campaigns$ | async">
    <mat-card class="card">
      <mat-card-header class="card-header">
        <mat-card-title *ngIf="campaign.title" class="name">
          <a [routerLink]="campaign.link">{{ campaign.title }}</a>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content class="content">
        <glxy-badge color="green" size="small">{{ campaign.status }}</glxy-badge>
      </mat-card-content>
    </mat-card>
  </ng-container>
  @if (canViewAllCampaigns$ | async) {
    <button mat-stroked-button color="primary" class="association-button" (click)="viewAll()">
      {{ 'ASSOCIATIONS.CAMPAIGNS.VIEW_ALL' | translate }}
    </button>
  }
</mat-expansion-panel>
